import React, { useEffect, useState } from "react";
import Libelle from "../../../_i18n/fr.json";
import Layout from "../../../components/Layout";
import MessageInfo from "../../../components/MessageInfo";

import { AdministrateurBienDetail, Site } from "../../../services/Api/swagger";
import { ISelectAdbSiteFormData, validateForm } from "./helpers";
import SelectAdbSiteForm from "./selectAdbSiteForm";
import { useSelectAdbSite } from "./selectors";
import { useNavigate } from "react-router";
import { Form } from "react-final-form";

function SelectAdbSitePage() {
  const {
    utilisateurConnecte,
    getAdbDetail,
    adbFetching,
    adbError,
    adbDetail,
    selectedAdbDetail,
    selectedSiteDetails,
    adbId,
    setSelectedSite,
    updateAdbId,
  } = useSelectAdbSite();

  // const handleSelectAdb = (idAdb: string) => {
  //   if (idAdb && idAdb !== "") {
  //     getAdbDetail(idAdb);
  //     updateAdbId(Number(idAdb));
  //   }
  // };

  // const handleSelectSite = (idSite: string) => {
  //   if (idSite && idSite !== "") {
  //     const sites = selectedAdbDetail && selectedAdbDetail.sites;
  //     const site =
  //       sites && sites.find((s) => s.numero && s.numero === Number(idSite));
  //     site && setSelectedSite(site);
  //   }
  // };

  const navigate = useNavigate();
  const handleSubmit = (selectForm: ISelectAdbSiteFormData) => {
    if (selectForm.adb && selectForm.site) {
      const sites = selectedAdbDetail && selectedAdbDetail.sites;
      const site =
        sites &&
        sites.find((s) => s.numero && s.numero === Number(selectForm.site));
      site && setSelectedSite(site);
      getAdbDetail(selectForm.adb);
      updateAdbId(Number(selectForm.adb));
      navigate("/dossier-location/bien");
    }
  };

  // const {
  //   utilisateurConnecte,
  //   selectedAdbDetail,
  //   selectedSiteDetails,
  //   adbFetching,
  //   idAdb,
  //   adbDetail,
  // } = ;

  const [listAdb, setListAdb] =
    useState<
      (
        | { identifiant: number | undefined; nom: string | undefined }
        | AdministrateurBienDetail
      )[]
    >();
  const [sitesAutorisesDetails, setSitesAutorisesDetails] =
    useState<Site[] | undefined>();
  const [messageBloquerAdb, setMessageBloquerAdb] =
    useState<"" | JSX.Element | undefined>();

  useEffect(() => {
    if (
      utilisateurConnecte?.role === "ADB" &&
      utilisateurConnecte.detailAdbProfilSites
    ) {
      const selectedAdb = utilisateurConnecte.detailAdbProfilSites.find(
        (adb) =>
          adb &&
          selectedAdbDetail &&
          adb.refAdb === selectedAdbDetail.identifiant
      );
      const sitesAutorisee = selectedAdb && selectedAdb.sites;
      setSitesAutorisesDetails(
        sitesAutorisee &&
          selectedAdbDetail?.sites?.filter(
            (s) => s.numero && sitesAutorisee.includes(s.numero)
          )
      );
      setListAdb(
        utilisateurConnecte.detailAdbProfilSites.map((adb) => ({
          identifiant: adb.refAdb,
          nom: adb.nomAdb,
        }))
      );
    } else if (utilisateurConnecte?.role === "BESSE" && adbId && adbDetail) {
      // const adbfinded = adbDetail.find((s) => adbId === s.identifiant);
      setListAdb(adbDetail ? [adbDetail] : []);
      setSitesAutorisesDetails(adbDetail ? adbDetail.sites : []);
      setMessageBloquerAdb(
        (adbDetail &&
          adbDetail?.applications &&
          adbDetail?.applications[0]?.parametrage &&
          !adbDetail.applications[0].parametrage?.actif) ||
          (adbDetail &&
            adbDetail.applications &&
            adbDetail.applications.length === 0) ? (
          <MessageInfo messageUrl="L'administrateur de bien que vous avez sélectionné n'est pas activé, veuillez l'activer afin de pouvoir créer un dossier de location" />
        ) : (
          ""
        )
      );
    }
  }, [utilisateurConnecte]);

  const onlyBesse =
    utilisateurConnecte && utilisateurConnecte.role === "BESSE" && !adbId;

  const infoAdbUtilisateurs = onlyBesse ? (
    <MessageInfo
      messageUrl="sélectionner un administrateur de bien"
      url="/mes-administrateurs-de-biens"
    >
      Pour visualiser les sites d'un administrateur de bien, veuillez en
      sélectionner un :
    </MessageInfo>
  ) : (
    ""
  );

  return (
    <React.Fragment>
      <Layout title={Libelle.pageSelectAdbSite.titre}>
        <>
          {infoAdbUtilisateurs}
          {messageBloquerAdb ? (
            messageBloquerAdb
          ) : (
            <Form
              name="selectAdbSiteForm"
              initialValues={{
                adb: selectedAdbDetail
                  ? selectedAdbDetail.identifiant + ""
                  : "",
                site: selectedSiteDetails
                  ? selectedSiteDetails.numero + ""
                  : "",
              }}
              validate={validateForm}
              enableReinitialize={true}
              onSubmit={handleSubmit}
            >
              {({
                handleSubmit,
                pristine,
                submitting,
                form: { change },
                values,
              }) => (
                <SelectAdbSiteForm
                  change={change}
                  listAdb={listAdb}
                  listSite={sitesAutorisesDetails}
                  // onSelectAdb={handleSelectAdb}
                  // onSelectSite={handleSelectSite}
                  isFetching={adbFetching}
                  onSubmit={handleSubmit}
                />
              )}
            </Form>
          )}
        </>
      </Layout>
    </React.Fragment>
  );
}

export default SelectAdbSitePage;
